<template lang="pug">
  r-form(
    ref='form'
    submit-text='crear'
    title='Crear banco'
    v-bind='formProps'
    v-model='gBank'
    @reset='submitReset'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import TranslatorService from '@/services/translator'
  //
  import GBankFields from '@/views/General/GBank/GBankFields'
  import GBankModel from '@/models/General/GBank'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: GBankFields,
        }
      }
    },
    data() {
      return {
        gBank: new GBankModel({
          name: '',
          code: '',
        }),
      }
    },
    methods: {
      showCreateError(event) {
        this.$toast.error(TranslatorService(GBankModel, event.response.data))
      },
      showCreateSuccess() {
        this.$toast.success('Sucursal creada exitosamente')
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.toWait)
      },
      submitReset() {
        this.gBank.name = ''
        this.gBank.code = ''
      },
      toCreate() {
        return this
          .gBank
          .toCreate()
          .save()
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
      },
      toRedirect() {
        this.$router.push({ name: 'g-branch-office-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Crear sucursal')
    },
  }
</script>